import clsx from "clsx";
import { CSS } from "styled-components/dist/types";

type Props = {
    image: string | null;
    styles?: CSS.Properties;
    className?: string;
}

const ImagePreviewAtom = ({ image, styles, className }: Props) => {
    const _style: CSS.Properties  = {
        width: "15rem",
        minWidth: "15rem",
        height: "15rem",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: 'no-repeat',
        boxShadow: "0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075)",
        backgroundImage: image
        ? `url(${image})`
        : 'url("/media/avatars/user_default.jpg")',
        ... styles
    }

    return (
        <div 
            className={clsx("image-input-outline image-input-wrapper rounded border", className)}
            style={_style}
        >
        </div>
    )
}

export default ImagePreviewAtom;